import axios from 'axios';
import { BRAND_BASE_URL, STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getBrandNotification = data => {
  return axios({
    method: 'post',
    url:
      BRAND_BASE_URL +
      '/store/api/secure/v1/notification-config/brand-notification', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const getViewNotificationTemplate = () => {
  return axios({
    method: 'get',
    url: BRAND_BASE_URL + '/store/api/secure/v1/template-config', // for android use


    headers: getHeaders(),
  });
};


export const getStoreNotification = data => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/notification-config/store-notification', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const postMapStoreNotification = (data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/notification-config/map-store-notification', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const putMapStoreNotification = (data) => {
  return axios({
    method: 'put',
    url: STORE_BASE_URL +
      '/store/api/secure/v1/notification-config/map-store-notification', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const whatsAppNotification = (data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store-customer-notification',
    // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const brandWhatsappConfig = (brandId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/brand-whatsapp-config/' + brandId,
    // for android use
    headers: getHeaders(),
  });
};


export const orderFeedback = (data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/order-feedback/search',
    // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};